import { CreditCard } from 'data/shared/__autogenerated__/types/CreditCard';
import { CreditCardData } from 'data/shared/CreditCardData';

/**
 * Generates the full file path for a card's processed JSON file
 */
export const getCardFilePath = (
  cardId: CreditCard,
  timestamp: string
): string => {
  const cardData = CreditCardData[cardId];
  if (!cardData) {
    throw new Error(`Card data not found for ${cardId}`);
  }

  const bankName = cardData.bank_name || cardData.issuer || 'Unknown Bank';
  const cardName = cardId;

  // Convert bank name to filesystem-safe format
  const safeBankName = bankName
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s+/g, ' ');

  return `/Users/vincent/Projects/SmartWallet/tools/scraper/data/temp/banks/${safeBankName}/cards/${cardName}/processed/${timestamp}/${cardName}_processed.json`;
};

/**
 * Generates a cursor:// URL for opening a file in Cursor
 */
export const getCursorUrl = (filePath: string): string => {
  // cursor://file/ uses file:// protocol path format
  // We need to encode the path properly
  const encodedPath = filePath
    .replace(/\\/g, '/') // Normalize to forward slashes
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');

  return `cursor://file/${encodedPath}`;
};

/**
 * Copies text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to execCommand fallback
    }
  }
  // Fallback for non-secure contexts (e.g. HTTP during dev)
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
};
